import React, { Component } from 'react';
import { Dimensions, Platform, View } from 'react-native'

import {
  VFButton,
  VFText,
  Icon,
  QuickActionMenu,
  RadioButton,
} from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import { Images } from '../../Themes';
import LoginTestKeys from '../../Utils/LoginTestKeys';

import styles from './ChangeLanguage.Styles';
import ReactNativeModal from 'react-native-modal'

class ChangeLanguage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: props.currentSelectedLanguage,
    };
  }

  onChangeLanguage = code => {
    this.setState({
      selectedLanguage: code,
    });
  };

  render() {
    const { theme, isVisible, closeModal, languages, onConfirmSelectLanguage } = this.props;
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <ReactNativeModal
          isVisible={isVisible}
          backdropOpacity={0.5}
          onSwipeComplete={closeModal}
          onBackdropPress={closeModal}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
          >
            <VFText
              type="primary"
              i18nKey={'change_language_modal_subtitle'}
              style={styles.languageModelSubTitle}
            />
            {languages &&
              languages.map((item, index) => {
                return (
                  <View
                    style={styles.radioContainer(
                      languages.length - 1 != index,
                      theme
                    )}
                    testID={`langComponent${index}`}
                    key={index}
                  >
                    <View style={styles.iconTextContainer}>
                      <Icon
                        type="image"
                        source={Images[item.icon]}
                        size={34}
                        style={styles.radioIcon}
                      />
                      <VFText
                        type="primary"
                        i18nKey={item.title}
                        style={styles.radioText}
                      />
                    </View>

                    <RadioButton
                      testID={'langRadio'}
                      selected={this.state.selectedLanguage === item.identifier}
                      style={styles.radioBtn}
                      onPress={() => this.onChangeLanguage(item.identifier)}
                    />
                  </View>
                )
              })}

            <VFButton
              title={'change_language_modal_button'}
              style={styles.languageModelBtn}
              textStyle={styles.buttonTextStyle}
              onPress={() => {
                onConfirmSelectLanguage(this.state.selectedLanguage)
              }}
              testID="changeLanguageButton"
              textAccessibilityLabel="changeLanguageButton"
              type="primary"
            />

          </View>
        </ReactNativeModal>
      )
    }

    return (
      <QuickActionMenu
        isVisible={isVisible}
        toggleModal={closeModal}
        type="secondary"
        title="change_language_modal_title"
        titleStyle={styles.languageModelTitle}
        headerStyle={styles.languageModelHeader}
        containerStyle={styles.languageModelContainer}
        TitleAccessibilityLabel={LoginTestKeys.languageModelTitleText}
        closeIconAccessibilityLabel={LoginTestKeys.languageModelCloseIcon}
        allowFontScaling={true}
        testID={LoginTestKeys.languageModel}
      >
        <>
          <VFText
            type="primary"
            i18nKey={'change_language_modal_subtitle'}
            style={styles.languageModelSubTitle}
          />
          {languages &&
            languages.map((item, index) => {
              return (
                <View
                  style={styles.radioContainer(languages.length - 1 != index, theme)}
                  testID={`${LoginTestKeys.langComponent}${index}`}
                  key={index}
                >
                  <View style={styles.iconTextContainer}>
                    <Icon
                      type="image"
                      source={Images[item.icon]}
                      size={34}
                      style={styles.radioIcon}
                    />
                    <VFText type="primary" i18nKey={item.title} style={styles.radioText} />
                  </View>

                  <RadioButton
                    testID={LoginTestKeys.langRadio}
                    selected={this.state.selectedLanguage === item.identifier}
                    style={styles.radioBtn}
                    onPress={() => this.onChangeLanguage(item.identifier)}
                  />
                </View>
              );
            })}

          <VFButton
            title={'change_language_modal_button'}
            style={styles.languageModelBtn}
            textStyle={styles.buttonTextStyle}
            onPress={() => {
              onConfirmSelectLanguage(this.state.selectedLanguage);
            }}
            testID={LoginTestKeys.changeLanguageButton}
            textAccessibilityLabel={LoginTestKeys.changeLanguageButton}
            type="primary"
          />
        </>
      </QuickActionMenu>
    );
  }
}
ChangeLanguage.defaultProps = {
  theme: LightThemeColors,
};
ChangeLanguage.propTypes = {
  closeModal: PropTypes.func,
  onConfirmSelectLanguage: PropTypes.func,
  isVisible: PropTypes.bool,
  languages: PropTypes.array,
  currentSelectedLanguage: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default ChangeLanguage;
